export default "__VITE_ASSET__CxypOGa2__"